import * as yup from "yup";

const schema = yup.object().shape({
  name: yup.string().min(3).required(),
  phone: yup.string().max(16),
});

export default schema;
